import SeatClassType from "@Route/types/travelInfo/SeatClass.type";
import React from "react";
import {Colors} from "@Styles/Colors.style";
import IconConnected from "@Icons/ticket/IconConnected";

type CombinedClassLabelProps = {
    seatClass: SeatClassType
}

function CombinedClassBadge({seatClass}: CombinedClassLabelProps) {
    return (
        <span className="gb--badge-blue">
            <IconConnected
                fill={Colors.neutralDarkestColor}
            />
            <span>
                {seatClass.className}
            </span>
        </span>
    );
}

export default CombinedClassBadge;